export default __webpack_public_path__ + "static/media/study-bellwright.d9ab9790.png";